const NoteComponent = () => {
    return <div>
        <h3>Steps</h3>
        <ol>
            <li>Click on the first "Choose File": txt format (required);</li>
            <li>Click on the second "Choose File": jsonl format (optional);</li>
            <li>Choose the number of questions you want (optional);</li>
            <li>Click "Next Step".</li>
        </ol>
    </div>
}

export default NoteComponent;